define('views/modules/questionnaire/responses/answers/answer-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'collections/questionnaire/comments',
    // views
    'views/modules/questionnaire/responses/answers/answer-info-section',
    // templates
    'text!templates/modules/questionnaire/responses/answers/answer-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    CComments,
    // views
    VAnswerInfoSection,
    // templates
    TAnswerListItem
) {

    var VAnswerListItem = Backbone.View.extend({
        template: TAnswerListItem,

        regions: {
            infoSection: ".info-section",
            subSection: ".sub-section",
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                questionnaire: opt.questionnaire,
                response: opt.response,
                question: opt.questionnaire.getQuestionById(this.model.id)
            });

            var view = this.view = {
                infoSection: new VAnswerInfoSection({
                    model: this.response,
                    answer: this.model,
                }),
            };
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            if (this.canSetQuestion()) {
                this.model.setQuestion(this.questionnaire.getQuestionById(this.model.id).getName());
            }

            this.assign(view.infoSection, zone.$infoSection);

            return this;
        },

        canSetQuestion: function() {
            return this.model.isQuestionEmpty() && !_.isEmpty(this.questionnaire.getQuestionById(this.model.id).getName());
        }

        ////////////
        // events //
        ////////////

    });

    return VAnswerListItem;

});

